import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_MODIFIER_ITEM } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { UUID } from "src/types/shared.type";
import { RootState } from "src/store/index";
import { remove_modifier_item, set_delete_modal_item_id } from "src/store/features/modifier-items-slice";

export const useDeleteModifierItem = () => {
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();

  const [isDeletingModifierItem, setIsDeletingModifierItem] = useState(false);
  const { toBeDeletedModifierItemId } = useSelector(
    (state: RootState) => state.modifierItems
  );

  const deleteModifierItemMutation = useCallback(
    async () => {
      setIsDeletingModifierItem(true);
      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: UPDATE_MODIFIER_ITEM,
          variables: {
            updateModifierItemInput: {
              modifierItemCorrelationId: toBeDeletedModifierItemId,
              isActive: false,
            },
          },
        });

        if (data?.data?.updateModifierItem) {
          // Remove the item from Redux state
          dispatch(remove_modifier_item(toBeDeletedModifierItemId));
          dispatch(set_delete_modal_item_id(null));
          successToast("Modifier item has been deleted successfully!");
        }
      } catch (err) {
        console.error("Error deleting modifier item:", err);
      } finally {
        setIsDeletingModifierItem(false);
      }
    },
    [axBe, dispatch, toBeDeletedModifierItemId]
  );

  const handleOpenDeleteModal = useCallback((correlationId: UUID) => {
    dispatch(set_delete_modal_item_id(correlationId));
  }, [dispatch]);

  const handleCloseDeleteModal = useCallback(() => {
    dispatch(set_delete_modal_item_id(null));
  }, [dispatch]);

  return {
    isDeletingModifierItem,
    deleteModifierItemMutation,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
  };
};
